module.exports = __webpack_public_path__ + "static/media/icon_info.4d273383.svg";